import { createStore } from "vuex";

// state, getters, mutations, actions, modules
export default createStore({
    state : {
        isLogin : false,
        auth: -1
    },
    getters : {
        getLoginStatus: state=>{
            return state.isLogin;
        },
        getAuthStatus: state=>{
            return state.auth;
        }
    },
    mutations : {
        setLogin(state){
            state.isLogin = true;
        },
        setLogout(state){
            state.isLogin = false;
            state.auth = -1;
        },
        setAuth(state, auth){
            state.auth = auth;
        }
    },
});